"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import Text from "../Text/index.js";
import { useFormControlPrivate } from "./FormControl.context.js";
import { getCaptionId } from "./FormControl.utilities.js";
import s from "./FormControl.module.css";
const FormControlCaption = (props) => {
    const { children, variant, disabled } = props;
    const { attributes, size, helperRef, errorRef } = useFormControlPrivate();
    const id = getCaptionId(attributes.id, variant);
    const color = variant === "error" ? "critical" : "neutral-faded";
    const ref = variant === "error" ? errorRef : helperRef;
    return (_jsx(Text, { as: "span", variant: size === "large" ? "body-3" : "caption-1", color: disabled && !variant ? "disabled" : color, attributes: { id, role: color ? "alert" : undefined, "aria-disabled": disabled, ref }, className: s.caption, children: children }));
};
export default FormControlCaption;
